import { render } from "./AposTranslationIndicator.vue?vue&type=template&id=31e222ad"
import script from "./AposTranslationIndicator.vue?vue&type=script&lang=js"
export * from "./AposTranslationIndicator.vue?vue&type=script&lang=js"

import "./AposTranslationIndicator.vue?vue&type=style&index=0&id=31e222ad&lang=scss"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"translation/ui/apos/components/AposTranslationIndicator.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "31e222ad"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('31e222ad', __exports__)) {
    api.reload('31e222ad', __exports__)
  }
  
  module.hot.accept("./AposTranslationIndicator.vue?vue&type=template&id=31e222ad", () => {
    api.rerender('31e222ad', render)
  })

}


export default __exports__